<template>
  <section>
    <h3 class="primary--text"><v-icon info>folder</v-icon> {{ title }}</h3>

    <v-card>
      <v-card-text>
        <crud-table
          :headers="headers"
          :url="url"
          :filters="filters"
          :graphql="graphql"
          :data-graphql="dataGraphql"
          :showFilter="true"
        >
          <template slot="labels">
            <div class="text-xs-right" v-if="this.regionales.length > 1">
              <v-select
                label="Regional"
                v-model="regional"
                :items="regionales"
              ></v-select>
            </div>
            <div class="text-xs-right" v-else>
              <strong>REGIONAL: </strong>
              <v-chip label color="info" text-color="white">
                {{ user.departamento.split(',').join(' - ') }}
              </v-chip>
            </div>
          </template>


          <template slot="items" slot-scope="items">
            <td class="text-xs-right">{{ items.item.id }}</td>
            <td class="nowrap">
              <div>
                <v-btn
                  small
                  @click="openDetalle(items.item)">
                  <v-icon>remove_red_eye</v-icon> Detalles
                </v-btn>
                <v-btn
                  small
                  icon
                  @click="descargar(items.item)">
                  <v-icon>file_download</v-icon>
                </v-btn>
              </div>
            </td>
            <td>
              <v-chip label :color="estados[items.item.estado]" text-color="white">
                <small>{{ items.item.estado.replace(/_/gi, ' ') }}</small>
              </v-chip>
            </td>
            <td class="text-xs-right">{{ items.item.nro_apostilla }}</td>
            <td class="text-xs-right">{{ items.item.tramite_cod_seguimiento }}</td>
            <td>{{ $datetime.format(items.item.fecha_expedicion) }}</td>
            <td>{{ items.item.documento_nombre }}</td>
            <td>
              <em><strong>{{ items.item.tramite_solicitante_tipo_documento }}: </strong>{{ items.item.tramite_solicitante_nro_documento }}</em><br>
              {{ items.item.tramite_solicitante_nombres }}
              {{ items.item.tramite_solicitante_primer_apellido }}
              {{ items.item.tramite_solicitante_segundo_apellido }}
            </td>
            <td>{{ $datetime.format(items.item._created_at) }}</td>
            <td class="text-xs-center">
              <v-icon v-if="items.item.pago_entidad || items.item.pago_cancilleria" color="success">check</v-icon>
              <v-icon v-else color="error">close</v-icon>
            </td>
          </template>
        </crud-table>
      </v-card-text>
    </v-card>
    <v-dialog v-model="$store.state.modal2" max-width="1200">
      <detalle :solicitud="solicitud" v-if="solicitud"></detalle>
    </v-dialog>
  </section>
</template>
<script>
import CrudTable from '@/common/util/crud-table/CrudTable.vue';
import crud from '@/common/util/crud-table/mixins/crud-table';
import tramiteDoc from './mixins/tramite_doc';
import Detalle from './Detalle';
import { mapState } from 'vuex';
import usuario from '@/components/admin/usuario/mixins/usuario';
import axios from 'axios';

const regionales = [
  'LA PAZ',
  'COCHABAMBA',
  'SANTA CRUZ'
];

const estados = {
  CREADO: 'success',
  REVISADO_ENTIDAD: 'info',
  OBSERVADO_ENTIDAD_REVISOR: 'warning',
  OBSERVADO_ENTIDAD_FIRMANTE: 'warning',
  FIRMADO_ENTIDAD: 'success',
  REVISADO_CANCILLERIA: 'info',
  OBSERVADO_CANCILLERIA_REVISOR: 'warning',
  OBSERVADO_CANCILLERIA_FIRMANTE: 'warning',
  APOSTILLADO: 'primary'
};

export default {
  mixins: [ crud, tramiteDoc, usuario ],
  created () {
    this.user = this.$storage.getUser();
    this.usuario = this.user.usuario;
    this.departamento = this.user.departamento;
    this.$store.state.modal2 = false;
    this.documentos = [];
    this.getDocumentos(1);

    this.regionales = this.user.departamento.split(',');

    if (this.regionales.length === 1 && this.regionales[0].length < 1) {
      this.getRegionales();
    }
    // this.regional = this.user.departamento;

    switch (this.user.id_rol) {
      case 6: // rol: Revisor Entidad
        this.filters[this.filters.length - 1].items = [
          { value: 'REVISADO_ENTIDAD', text: 'REVISADO ENTIDAD' }
        ];
        break;
      case 7: // rol: Firmador Entidad
        this.filters[this.filters.length - 1].items = [
          { value: 'FIRMADO_ENTIDAD', text: 'FIRMADO ENTIDAD' }
        ];
        break;
      case 3: // rol: Revisor Cancilleria
        this.filters[this.filters.length - 1].items = [
          { value: 'REVISADO_CANCILLERIA', text: 'REVISADO CANCILLERIA' }
        ];
        break;
      case 4: // rol: Firmador Cancilleria
        this.filters[this.filters.length - 1].items = [
          { value: 'APOSTILLADO', text: 'APOSTILLADO' },
          { value: 'OBSERVADO_CANCILLERIA_FIRMANTE', text: 'OBSERVADO CANCILLERIA FIRMANTE' }
        ];
        break;
      default:
        this.filters[this.filters.length - 1].items = [
          { value: 'CREADO', text: 'CREADO' }];
    }
    this.filters[this.filters.length - 2].value = this.departamento;
  },
  data () {
    return {
      graphql: true, // Definiendo el CRUD con Graphql
      url: 'historial',
      headers: [
        { text: this.$t('N° Trámite'), value: 'id' },
        { text: this.$t('common.actions'), sortable: false },
        { text: this.$t('tramite_doc.crud.estado'), value: 'estado' },
        { text: this.$t('tramite_doc.crud.nro_apostilla'), value: 'nro_apostilla' },
        { text: this.$t('tramite_doc.crud.cod_seguridad'), value: 'cod_seguridad' },
        { text: this.$t('tramite_doc.crud.fecha_expedicion'), value: 'fecha_expedicion' },
        { text: this.$t('tramite_doc.crud.documento_nombre'), value: 'documento_nombre' },
        { text: this.$t('tramite_doc.crud.nombre_solicitante'), value: 'id_tramite' },
        { text: this.$t('tramite_doc.crud.fecha_solicitud'), value: '_created_at' },
        { text: this.$t('tramite_doc.crud.pago'), value: 'pago_entidad', sortable: true }
      ],
      regionales,
      regional: '',
      dataGraphql: `
        id
        pago_entidad
        pago_cancilleria
        cod_seguridad
        nro_apostilla
        fecha_expedicion
        estado
        observacion
        id_tramite
        id_documento
        id_archivo
        documento_nombre
        tramite_solicitante_nombres
        tramite_solicitante_primer_apellido
        tramite_solicitante_segundo_apellido
        tramite_solicitante_nro_documento
        tramite_solicitante_tipo_documento
        tramite_solicitante_email
        tramite_cod_seguimiento
        _created_at
      `,
      filters: [
        {
          field: 'id',
          label: 'Nro. de tramite',
          type: 'text',
          typeG: 'Int'
        },
        {
          field: 'id_documento',
          label: this.$t('tramite_doc.crud.docName'),
          type: 'select',
          typeG: 'Int',
          items: []
        },
        {
          field: 'cod_seguridad',
          label: this.$t('tramite_doc.crud.cod_seguridad'),
          type: 'text',
          typeG: 'String'
        },
        {
          field: 'cod_seguimiento',
          label: 'Código de seguimiento',
          type: 'text',
          typeG: 'String'
        },
        {
          field: 'nro_apostilla',
          label: this.$t('tramite_doc.crud.nro_apostilla'),
          type: 'text',
          typeG: 'String'
        },
        {
          field: 'nro_documento',
          label: 'Nro. de documento solicitante',
          type: 'text',
          typeG: 'String'
        },
        {
          field: 'nombre_completo',
          label: 'Nombre del solicitante',
          type: 'text',
          typeG: 'String'
        },
        {
          field: 'departamento',
          label: 'Regional',
          type: 'hidden',
          typeG: 'String',
          value: ''
        },
        {
          field: 'estado',
          label: this.$t('tramite_doc.crud.status'),
          type: 'select',
          typeG: 'EstadoTramiteDoc',
          items: []
        }
      ],
      solicitud: null,
      estados
    };
  },
  methods: {
    openDetalle (item) {
      this.solicitud = null;
      this.$nextTick(() => {
        this.solicitud = item;
        this.$store.commit('openModal', 2);
      });
    },
    descargar (item) {
      const url = item.estado === 'APOSTILLADO' ? this.$apiUrl + 'eregister/pdf-download_apostilla/' + item.id_archivo : this.$apiUrl + 'eregister/pdf-download/' + item.id_archivo;
      axios({
        url: url,
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + this.$storage.get('token')
        },
        json: true,
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        const d = new Date();
        link.setAttribute('download', this.$store.state.user.usuario + d.getTime() + '.pdf');
        document.body.appendChild(link);
        link.click();
      }).catch(error => {
        this.$message.error(error);
      });
    }
  },
  components: {
    CrudTable,
    Detalle
  },
  computed: {
    ...mapState(['modal2  ']),
    title () {
      let titulos = {
        '6': 'Historial de documentos revisados por la entidad',
        '7': 'Historial de documentos firmado por la entidad',
        '3': 'Historial de documentos revisado por la cancillería',
        '4': 'Historial de documentos apostillados'
      };
      if (titulos[this.user.id_rol]) {
        return titulos[this.user.id_rol];
      }
      return 'Historial';
    }
  },
  watch: {
    '$store.state.modal2': function (val) {
      if (!val) {
        this.$store.commit('setArchivo', 1);
      }
    },
    'regional': function (val) {
      if (val) {
        console.log('dep', val);
        this.filters[this.filters.length - 2].value = val;
        this.updateList();
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// Historial.vue?7d9cf8a8